import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'

function Copyrights({ shortName }) {
	return (
		<div className="copyright-info text-center">
			&copy; {new Date().getFullYear()}, <Link to={`/`}>{shortName}</Link> - All
			right reserved.
		</div>
	)
}

const copyrightsQuery = graphql`
	{
		allSite {
			nodes {
				siteMetadata {
					themeOptions {
						site {
							shortName
						}
					}
				}
			}
		}
	}
`

function StaticCopyrights() {
	return (
		<StaticQuery
			query={copyrightsQuery}
			render={data => (
				<Copyrights
					shortName={
						data.allSite.nodes[0].siteMetadata.themeOptions.site.shortName
					}
				/>
			)}
		/>
	)
}

export default StaticCopyrights
